export default __webpack_public_path__ + "static/media/FionaPaolaLogo.9949bc0c.svg";